import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/CANYON/CANYON_Deploy_Prod@2/layouts/default.vue").then(m => m.default || m))
}